import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDCLbLQ5pzNyze72-G1Xk4E_VKbzGGF-JA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "coursetube-pro.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://coursetube-pro-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "coursetube-pro",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "coursetube-pro.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "607103099475",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:607103099475:web:12692d49661e886f4d1ca6",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-5KED3VEX8T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app, 'passiton'); // Use passiton database
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

// Note: Firestore settings are now configured differently in Firebase v9+
// The experimentalForceLongPolling setting is no longer needed for most cases
// If you experience connection issues, they're usually resolved by:
// 1. Proper Firestore security rules
// 2. Correct database configuration
// 3. Network connectivity

export default app;
